import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${props => `rgba(0, 0, 0, ${props.opacity})`};
`;

class ModalBase extends PureComponent {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.modalRoot = document.getElementById('modal-root');
  }
  escFunction = event => {
    if (event.keyCode === 27) {
      this.props.onClose(event);
    }
  };
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
    this.modalRoot.appendChild(this.el);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
    this.modalRoot.removeChild(this.el);
  }
  render() {
    return ReactDOM.createPortal(
      <Overlay onClick={this.props.onClose} opacity={this.props.opacity}>
        {this.props.children}
      </Overlay>,
      this.el
    );
  }
}

ModalBase.propTypes = {
  opacity: PropTypes.number,
  onClose: PropTypes.func.isRequired
};

ModalBase.defaultProps = {
  opacity: 0.6
};

export default ModalBase;
